<template>
    <div class="contain">
        <div class="bannerImg">
            <img src="../assets/banner3.png" alt="">
            <a href="tel:0551-68856050"></a>
        </div>
        <div class="showImg">
            <div class="mapImg" @click="showMap()">
                <img src="../assets/mapImg.png" alt="">
            </div>
            <div class="showBtn" v-show="!tipshow">
                <div class="active" @click="showPop(1)">公交站台广告位</div>
                <div class="" @click="showPop(2)">小区电梯屏广告位</div>
                <div class="" @click="showPop(3)">LED大屏广告位</div>
                <div class="" @click="showMap()">更多详情</div>
            </div>
        </div>
        <div class="tipPop" v-show="tipshow">
            <div class="tipPopCon">
                <div class="tipPop_img">
                    <!-- <img src="../assets/mapImg.png" alt=""> -->
                    <img src="../assets/mapImg01.png" alt="" v-if="maptype==1">
                    <img src="../assets/mapImg02.png" alt="" v-if="maptype==2">
                    <img src="../assets/mapImg03.png" alt="" v-if="maptype==3">
                </div>
                <div class="tipPop_txt">
                    肥西县数字传媒公司全县共有电梯屏幕3000部，分布在全县16个乡镇园区的87个小区内覆盖面广，传播效果好。
                </div>
                <div class="tipPop_tel">
                    联系电话:0551-6885-6050
                </div>
            </div>
            <div class="tipPopClose" @click="hidePop()">
                <img src="../assets/close2.png" alt="">
            </div>
        </div>
        <div class="maskBg" v-show="tipshow" @click="hidePop()"></div>
        <!-- <baidu-map @ready="mapReady"></baidu-map> -->
    </div>
</template>
<script>
    export default {
        data() {
            return {
                tipshow:false,
                maptype:1
            }
        },
        mounted() {},
        methods: {
            showMap(){
              this.$emit('xgMap',{type:1,value:''})
            },
            showPop(e){
              if(e==1){
                this.$emit('xgMap',{type:2,value:'1bab8c45ee741f589068c2bf52ed3d02'})
              }
              if(e==2){
                this.$emit('xgMap',{type:2,value:'ffb9b5fccbf8fa8c6c1bc068536c8fca'})
              }
              if(e==3){
                this.$emit('xgMap',{type:2,value:'76049dd4276a32f586fe9a3439a30bf4'})
              }
              // this.maptype = e
              // this.tipshow = true
            },
            hidePop(){
              this.tipshow = false
            },
            mapReady({BMap,map}) {
              let geolocation = new BMap.Geolocation()
              geolocation.enableSDKLocation(); //允许SDK辅助
              geolocation.getCurrentPosition(e=>{
                console.log(e)
                if(e.latitude){
                  localStorage.setItem('location',true)
                  localStorage.setItem('locationInfo',e)
                }else{
                  localStorage.setItem('location',false)
                }
              })
            },
        }
    }
</script>
<style scoped>
    .contain{
        width: 100%;
        height: 100%;
        background: linear-gradient(269deg, #53A1F8 0%, #6889F4 100%);
        overflow: hidden;
    }
    
  .bannerImg{
    position: fixed;
    top: .4rem;
    left: .4rem;
    width: 5.72rem;
    z-index: 100;
  }
  .bannerImg img{
    width: 100%;
    height: 1.46rem;
  }
  .bannerImg a{
    position: absolute;
    top: 0;
    right: 0;
    display: block;
    height: 1.46rem;
    width: 3rem;
  }
  .showImg{
    width: 7.1rem;
    margin: 0rem auto;
    height: 98vh;
    padding-top: 18vh;
    position: relative;
    overflow: hidden;
    border-radius: 0.52rem;
  }
  .mapImg{
    width: 100%;
    height: 100%;
  }
  .mapImg img{
    width: 100%;
    height: 100%;
  }
  .showBtn{
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 6.4rem;
    background: linear-gradient(180deg, rgba(243,243,245,0) 0%, #F3F3F5 11%, #F3F3F5 100%);
    padding-top: 1rem;
  }
  .showBtn div{
    width: 5.6rem;
    line-height: 1.04rem;
    background: #FFFFFF;
    box-shadow: 0rem 0.1rem 0.12rem 0.02rem rgba(67,131,175,0.1);
    border-radius: 0.56rem 0.56rem 0.56rem 0.56rem;
    border: 0.02rem solid #E9E9E9;
    font-size: 0.32rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #242F44;
    text-align: center;
    margin: .1rem auto;
  }
  .showBtn div.active{
    background: linear-gradient(274deg, #53A1F8 0%, #6889F4 100%);
    box-shadow: 0rem 0.1rem 0.12rem 0.02rem rgba(67,131,175,0.3);
    color: #FFFFFF;
  }
  .maskBg{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background-color: rgba(0, 0, 0, .5);
  }
  .tipPop{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 101;
    width: 6rem;
    height: 8.45rem;
  }
  .tipPopCon{
    width: 6rem;
    height: 7.6rem;
    background: url(../assets/tipBg.png) no-repeat;
    background-size: 100% 100%;
    padding-top: .24rem;
  }
  .tipPopCon .tipPop_img{
    margin: 0rem auto;
    width: 5.6rem;
    height: 3.4rem;
    border-radius: .16rem;
  }
  .tipPopCon .tipPop_img img{
    width: 5.6rem;
    height: 3.4rem;
  }
  .tipPopCon .tipPop_txt{
    font-size: 0.28rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 0.56rem;
    text-shadow: 0px 0px 0px rgba(16,77,119,0.4);
    margin: .4rem auto .64rem;
    width: 5.2rem;
  }
  .tipPopCon .tipPop_tel{
    width: 100%;
    background-color: #2F73BF;
    line-height: .96rem;
    text-align: center;
    font-size: 0.24rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
  }
  .tipPopCon .tipPop_tel img{}
  .tipPopClose{
    width: 0.64rem;
    height: .64rem;
    margin: .2rem auto 0;
  }
  .tipPopClose img{
    width: 100%;
    height: 100%;
  }
</style>